import { Link } from 'react-router-dom';
import { CreditCard, ArrowDownToLine } from 'lucide-react';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';

const withdrawalStatusConfig = {
  pending: { label: 'Pending', color: 'bg-yellow-500/10 text-yellow-500' },
  completed: { label: 'Completed', color: 'bg-green-500/10 text-green-500' },
  rejected: { label: 'Rejected', color: 'bg-red-500/10 text-red-500' },
  failed: { label: 'Failed', color: 'bg-red-500/10 text-red-500' },
};

const payoutMethodLabel = (p) => {
  if (!p) return 'Not set';
  if (p.stripe_connect_status === 'active') return 'Bank Account (auto via Stripe)';
  const m = p.payout_method || p.preferred_payment_method;
  if (m === 'paypal') return `PayPal: ${p.paypal_email || 'not set'}`;
  if (m === 'zelle') return `Zelle: ${p.zelle_email || p.zelle_phone || 'not set'}`;
  if (m === 'bank_transfer') return `Bank Transfer: ${p.bank_name || 'not set'}`;
  return 'Not set';
};

export function WithdrawalsTab({ profile, withdrawals }) {
  return (
    <div className="space-y-6">
      {profile && (
        <div className="bg-surface border border-[#262626] rounded-xl p-6">
          <div className="flex items-center justify-between gap-4 flex-wrap">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 bg-lime/10 rounded-xl flex items-center justify-center">
                <CreditCard className="w-6 h-6 text-lime" />
              </div>
              <div>
                <p className="font-bold">Payout Method</p>
                <p className="text-sm text-[#A1A1AA]" data-testid="agent-payout-method">
                  {payoutMethodLabel(profile)}
                </p>
              </div>
            </div>
            <Button asChild variant="outline" className="border-[#333]" data-testid="manage-payout-btn">
              <Link to="/settings?tab=payment">Manage Payout Method</Link>
            </Button>
          </div>
        </div>
      )}
      {withdrawals.length > 0 ? (
        <div className="bg-surface border border-[#262626] rounded-xl overflow-hidden">
          <div className="p-4 border-b border-[#262626]">
            <h3 className="font-heading font-bold">Withdrawal History</h3>
          </div>
          <div className="divide-y divide-[#262626]">
            {withdrawals.map((w) => {
              const status = withdrawalStatusConfig[w.status] || { label: w.status, color: 'bg-gray-500/10 text-gray-400' };
              return (
                <div key={w.id} className="p-4 flex items-center justify-between" data-testid={`agent-withdrawal-row-${w.id}`}>
                  <div>
                    <p className="font-mono">${w.amount.toFixed(2)}</p>
                    <p className="text-xs text-[#A1A1AA]">{new Date(w.created_at).toLocaleDateString()}</p>
                  </div>
                  <div className="text-right">
                    <Badge className={`${status.color} border-0`}>{status.label}</Badge>
                    <p className="text-xs text-[#A1A1AA] mt-1">
                      via {w.payout_method === 'paypal' ? 'PayPal' : w.payout_method}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <div className="text-center py-16 bg-surface rounded-2xl border border-[#262626]">
          <ArrowDownToLine className="w-16 h-16 mx-auto mb-4 text-[#333]" />
          <h3 className="text-xl font-heading font-bold mb-2">No Withdrawals Yet</h3>
          <p className="text-[#A1A1AA]">Request a withdrawal when you have earnings available</p>
        </div>
      )}
    </div>
  );
}
